/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Checkbox } from 'antd'
import { omit } from 'lodash'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const CheckboxGroup = Checkbox.Group

const I2CheckBoxControl = (props) => {
  const {
    propsClassName, propsClassSpan, style,// 样式 className
    modalProps, label, ending, // 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    clearKey, killPending, reduxObj,// 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  const handleValue = Object.keys(query).includes(searchKey)
  ? query[searchKey].toString().split(',')
  : []
  const [ useValue, setUseValue ] = useState(handleValue)
  useEffect(() => {
    setUseValue(handleValue)
  }, [query.refQ, query[searchKey]])

  const onChangeSelect = (e) => {
    setUseValue(e)
    // ----- 处理数据 -----------
    let formatValue = e.join(',')
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: formatValue }
    )
  }
  return (

    <div className={propsClassName} style={{ lineHeight: '22px' }}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <CheckboxGroup
        options={options}
        {...modalProps}
        value={useValue}
        onChange={onChangeSelect}
      />
    </div>
  )

}

export default I2CheckBoxControl

I2CheckBoxControl.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  query: {},
  options: [],
  killPending: false
}
